const ScrollToElement = (id: string): void => {
  const rootElm = document.getElementById(id);
  if (!rootElm) return;

  const headerElm = document.querySelector<HTMLElement>('.page-header');
  const headerHeight = headerElm?.offsetHeight;

  let top = rootElm.offsetTop - 50;
  const isDesktop = window.innerWidth > 1068;

  if (isDesktop && headerHeight) {
    top -= headerHeight;
  }

  window.scrollTo({ behavior: 'smooth', top });
};

export default ScrollToElement;
